import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // To access dynamic route parameters
import axios from "axios";
import config from "../../config";
import useAxios from "../../utils/useAxios";
import { useAppContext } from "../../context/AppContext";
import { hideModal, showModal } from "../../utils/modalUtility";

const Courses = () => {
  const [posts, setPosts] = useState([]); // State to hold fetched posts
  const [loading, setLoading] = useState(true);
  const [totalPost, setTotalCoursesPosts] = useState(0); // Total number of eventPosts
  const [searchQuery, setSearchQuery] = useState("");
  const [status, setStatus] = useState();
  const { state } = useAppContext();

  const [courseData, setCourseData] = useState([]);
  const [selectedAarti, setSelectedAarti] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [role, setRole] = useState(null);

  const axiosAPI = useAxios();

  const [formData, setFormData] = useState({
    course_name: "",
    description: "",
    thumbnail_url: "",
    registration_link: "",
  });

  // Fetch Courses data
  const getCourses = async () => {
    try {
      const response = await axiosAPI.get("/api/other/setting/get-courses");
      const data = response.data.results || [];
      setCourseData(data);
      setTotalCoursesPosts(data.length);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string
    const role = state?.user?.role;
    setRole(role);
  }, []);

  useEffect(() => {
    getCourses();
  }, []); // Rerun this effect when eventUrlSlug changes

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!posts) {
    return <div>Event not found!</div>;
  }

  const editPostDetails = async (id) => {
    console.log("CLick", id);
    setCurrentUserId(id.id);
    showModal("newUserModal");
    setFormData(id);
  };

  // Close Modal
  const closeModal = () => {
    // setIsEditMode(false);
    // removeFormData();
    // setCurrentUserId(null);
    hideModal("newUserModal");
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      thumbnail_url: formData.thumbnail_url,
      registration_link: formData.registration_link,
    };

    // console.log(payload);

    // return

    try {
      let response = await axiosAPI.put(
        `/api/other/setting/update-course/${currentUserId}`,
        payload
      );
      window.notifyMessage(
        "Success",
        "Course Details updated successfully",
        "success"
      );

      hideModal("newUserModal");
      getCourses();
      //   removeFormData();
      //   setIsEditMode(false);
      // window.location.reload(); // Reload page to reflect changes in the Aarti Details list
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  // Status Update Code
  const handleStatusChange = (e, screenId) => {
    console.log(screenId);
    const updatedOrientation = e.target.value;
    console.log(updatedOrientation);

    // Update the screen orientation in the local state
    const updatedScreens = courseData.map((screen) =>
      screen.id === screenId
        ? { ...screen, status: updatedOrientation }
        : screen
    );

    setCourseData(updatedScreens);

    console.log(updatedScreens);

    // return

    axiosAPI
      .put(`/api/other/setting/update-aarti-status/${screenId}`, {
        status: updatedOrientation,
      })
      .then((response) => {
        console.log("Status updated successfully:", response);
        // getOnlineTestsList();
      })
      .catch((error) => {
        console.error("Error updating orientation:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          window.notifyMessage(
            "Error",
            error.response.data.message, // Display the specific error message from the backend
            "danger"
          );
        } else {
          // Handle generic errors (e.g., network errors)
          window.notifyMessage("Error", "Error updating orientation", "danger");
        }
      });
  };

  // Handle input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter posts based on search query and selected status
  const filteredPosts = posts.filter(
    (post) =>
      post.caption.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.person_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.person_city.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Function to truncate captions to a max of 120 characters
  const truncateCaption = (caption) => {
    if (caption && caption.length > 120) {
      return caption.substring(0, 120) + "...";
    }
    return caption;
  };

  const openPostModal = (post) => {
    setSelectedAarti(post);
    showModal("postModal");
    // console.log({ media });
  };


  return (
    <div className="container">
      <main className="page-inner">
        <div className="card my-4">
          <div className="card-body">
            <div className="d-flex mb-2 align-items-center">
              <div className="flex-grow-1">
                <div className="card-title text-uppercase fs-6">
                  All Courses
                  <br />
                  <div className="form-text">Total Course - {totalPost}</div>
                </div>
              </div>
              <div>
                <div className="d-flex d-none">
                  <input
                    className="form-control me-2 rounded-pill"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row" id="m-posts-container">
          {courseData.map((post) => (
            <div
              key={post.id}
              className={`col-12 col-sm-6 col-md-4 col-lg-3 posts-container-column`}
            >
              <div className="card">
                <div className="position-relative">
                  {/* Media - Image or Video */}
                  <img
                    src={post?.thumbnail_url || "/assets/img/image-holder.jpg"} // Default image URL if no media is available
                    className="card-img-top img-fluid custom-card-height cursor-pointer "
                    alt="Post Image"
                    onClick={() => openPostModal(post)}
                  />
                </div>
                <div className="card-body pt-1">
                  <div className="d-flex justify-content-between">
                    <span className="fw-bold text-truncate">
                      {post.aarti_name}
                    </span>
                  </div>

                  <p className="text-muted small mb-3 pt-2 caption-area">
                    {truncateCaption(post?.description) ||
                      "No caption available"}
                  </p>

                  <div className="d-flex m-action-button-icons">
                    {role === "admin" ? (
                      <button
                        type="button"
                        className="btn btn-grey"
                        onClick={() => editPostDetails(post)}
                      >
                        <i className="fa fa-edit me-1"></i> Edit Details
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() =>
                          window.open(`${post.registration_link}`, "_blank")
                        }
                      >
                        Apply Now
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Edit Modal Code */}
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  Edit Course Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body modal-xl">
                <form onSubmit={handleSubmit}>
                  {/* Title (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="course_name" className="form-label">
                      Course Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="course_name"
                      placeholder="Enter course name"
                      value={formData.course_name}
                      disabled
                      //   onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="thumbnail_url" className="form-label">
                      Thumbnail Url
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="thumbnail_url"
                      placeholder="Enter thumbnail url"
                      value={formData.thumbnail_url}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="registration_link" className="form-label">
                      Registeration Link
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="registration_link"
                      placeholder="Enter registration link"
                      value={formData.registration_link}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Message (Text Area) */}
                  <div className="mb-3">
                    <label htmlFor="course_description" className="form-label">
                      Course Description
                    </label>
                    <textarea
                      className="form-control"
                      id="course_description"
                      rows="4"
                      placeholder="Enter course description"
                      value={formData.description}
                      //   onChange={handleChange}
                      disabled
                      required
                    ></textarea>
                  </div>

                  {/* <div className="mb-3">

                  <select
                    className="form-select"
                    value={status}
                    onChange={(e) => handleStatusChange(e, currentUserId)}
                  >
                    <option value="active">active</option>
                    <option value="inactive">inactive</option>
                  </select>
                </div> */}

                  <button type="submit" className="btn btn-primary ">
                    Update Course Details
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="postModal"
          tabIndex="-1"
          aria-labelledby="postModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="d-flex justify-content-end p-2">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  {/* <i className="fa fa-times-circle fs-4 text-secondary"></i> */}
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 col-sm-12 mb-2">
                    <img
                      src={selectedAarti.thumbnail_url}
                      className="img-fluid rounded"
                      alt="Sample Image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div
          id="no-posts"
          className="text-center text-muted"
          style={{ display: filteredPosts.length === 0 ? "block" : "none" }}
        >
          <p>No posts found!</p>
        </div> */}
      </main>
    </div>
  );
};

export default Courses;
